import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fb32671"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = {
  id: "print",
  class: "col-12 text-end my-3 no-print print-button-container"
}
const _hoisted_3 = ["srcdoc"]

import { onMounted, onUnmounted, ref, Ref } from "vue";
import { print } from "@/utilities/index";
import { Printer } from "@element-plus/icons-vue";
import { getCustomerInvoice } from "@/api/customer";
import { useUserStore } from "@/stores/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceView',
  props: {
    invoiceId: {}
  },
  setup(__props: any) {

const props = __props;


const userStore = useUserStore();
let data = ref("");
let invoice: Ref<any> = ref(null);
let loadingHTML = ref(true);

window.addEventListener("scroll", positionPrintButton);

// A plain white page behind the invoice, not the portal's sprinkles.
onMounted(() => document.getElementById("app")?.classList.add("plain"));
onUnmounted(() => document.getElementById("app")?.classList.remove("plain"));

onMounted(async () => {
  window.addEventListener("resize", resizeIframe);

  await loadInitialData();
})

function positionPrintButton() {
  const navbar = document.getElementById("navbar");
  const print = document.getElementById("print");

  if (navbar && print) {
    if (navbar.style.top === "0px") {
      print.style.top = `${navbar.clientHeight + 10}px`
    } else {
      print.style.top = "10px";
    }
  }
}

// The invoice is a 600px email layout; on a phone it is shrunk to fit the screen instead of running off the edge.
function resizeIframe( ) {
  if(invoice.value) {
    const page = invoice.value.contentDocument.documentElement;
    page.style.zoom = "1";
    const zoom = Math.min(1, invoice.value.clientWidth / page.scrollWidth);
    page.style.zoom = String(zoom);
    invoice.value.style.height = `${Math.ceil(invoice.value.contentDocument.body.scrollHeight * zoom)}px`;
  }

  positionPrintButton()
}

async function loadInitialData() {
  await getCustomerInvoice(userStore.id, props.invoiceId).then((res) => {
    data.value = res.html;
    loadingHTML.value = false;

    setTimeout(() => {
      resizeIframe()
    }, 200);
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(loadingHTML))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(print) && _unref(print)(...args))),
            class: "btn btn-primary d-inline-flex align-items-center"
          }, [
            _createVNode(_component_el_icon, {
              class: "me-2",
              size: 20,
              color: "#FFF"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Printer))
              ]),
              _: 1
            }),
            _createTextVNode("Print ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["mb-3 iframe-border", { 'border border-1': !_unref(loadingHTML) }])
    }, [
      _createElementVNode("iframe", {
        ref_key: "invoice",
        ref: invoice,
        srcdoc: _unref(data),
        width: "100%",
        height: "1076px",
        frameborder: "0"
      }, null, 8, _hoisted_3)
    ], 2)
  ]))
}
}

})